import { windSpeedScalars } from 'data/windSpeedScalars';

interface Lv95Coordinate {
  x: number;
  y: number;
}

const calculateClosestStation = (pCenterOfPolygon: Lv95Coordinate) => {
  let closest = null;
  let closestDistance = Infinity;

  for (let i = 0; i < windSpeedScalars.length; i++) {
    let station = windSpeedScalars[i];
    let dx = pCenterOfPolygon.x - station.coordinate.x;
    let dy = pCenterOfPolygon.y - station.coordinate.y;
    let distance = Math.sqrt(dx * dx + dy * dy);

    if (distance < closestDistance) {
      closest = station;
      closestDistance = distance;
    }
  }

  return closest;
};

export { calculateClosestStation };
